<template>
  <button class="btn btn-spinner" :class="className" :type="type || 'button'" v-on:click.prevent="$emit('btnClick')" :disabled="disabled">
    <i class="icon" :class="{ spin: loading }" v-if="iconLeft && loading"></i>
    <slot></slot>
    <i class="icon" :class="{ spin: loading }" v-if="iconRight && loading"></i>
  </button>
</template>

<script>
export default {
  name: 'btn-spinner',
  props: ['type', 'loading', 'className', 'iconLeft', 'iconRight', 'disabled'],
  data() {
    return {}
  },
}
</script>



// WEBPACK FOOTER //
// src/components/BtnSpinner.vue